function requestAPI(token, code) {
  return fetch(`${process.env.REACT_APP_AGENT_URL}transaction/detail/${code}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionDetailTransaction(codeParam) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'DETAIL_TRANSACTION_BEGIN'
      })

      const token = (getState().auth && getState().auth.authenticate)
        ? getState().auth.authenticate.token
        : localStorage.getItem('nabawi-token')

      const result = await requestAPI(token, codeParam)

      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'DETAIL_TRANSACTION_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({
    type: 'DETAIL_TRANSACTION_FAILURE',
    error: error
  })
}
